jQuery(document).ready(() => {

	//////// ///     //////// /////// //////// ///
	///      ///     ///  /// ///  /  ///  /// ///
	//////// ///     ///  /// /////   ///  /// ///
	///  /// ///     ///  /// ////    //////// ///
	///  /// ///     ///  /// //  //  ///  /// ///
	//////// /////// //////// /////// ///  /// ///////


	// Verify Scroll Responsive and Scroll Desktop
	// Verify Position Levels Navbar on resize
	// Verify Scroll when is actived the Filter
	/////////////////////////////////////////////////////////////////////////////////////////

	const icon_nav_mb = jQuery(`[data-navbar='icon']`);
	const box_filter = jQuery(`[data-filter='box']`)

	const verifyScroll = () => {
		const width = jQuery(window).width();

		if (width >= 992) {

			jQuery('body').removeClass('scroll-hidden');
			box_filter.removeClass('active');

		} else {

			if (icon_nav_mb.children().hasClass('active')) {
				jQuery('body').addClass('scroll-hidden');
			} else {
				jQuery('body').removeClass('scroll-hidden');
			}
		}

	}

	verifyScroll();
	jQuery(window).resize(() => {
		verifyScroll();
	});

});